import { render } from "./WithdrawalAccount.vue?vue&type=template&id=0f7663d5"
import script from "./WithdrawalAccount.vue?vue&type=script&lang=js"
export * from "./WithdrawalAccount.vue?vue&type=script&lang=js"

import "./WithdrawalAccount.vue?vue&type=style&index=0&id=0f7663d5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__